<template>
  <v-row justify="center">
    <v-dialog
      v-model="curVisible"
      persistent
      max-width="600px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">查询条件</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 300px;min-height: 420px;overflow: auto;">
          <v-container>
            <v-row>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="car_no"
                  label="车牌号码"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  v-model="peccancy_type"
                  :items="peccancyItems"
                  item-text="state"
                  item-value="abbr"
                  label="违章类型"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  v-model="run_type"
                  :items="runItems"
                  item-text="state"
                  item-value="abbr"
                  label="行驶类型"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-select
                  v-model="seq_code"
                  :items="siteItems"
                  :disabled="siteDisable"
                  item-text="state"
                  item-value="abbr"
                  label="地点"
                ></v-select>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="dept"
                  label="部门"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="us_text"
                  label="联系人"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="car_type"
                  label="车型"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="car_no_color"
                  label="车牌颜色"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-text-field
                  v-model="car_color"
                  label="车辆颜色"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                sm="6"
                md="4"
              >
                <v-dialog
                  ref="dialog"
                  v-model="modal"
                  :return-value.sync="dates"
                  persistent
                  width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="dateRangeText"
                      label="时间"

                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dates"
                    range
                    scrollable
                    locale="zh-cn"
                  >
                    <v-spacer></v-spacer>
                    <v-btn
                      text
                      color="primary"
                      @click="modal = false"
                    >
                      取消
                    </v-btn>
                    <v-btn
                      text
                      color="primary"
                      @click="$refs.dialog.save(dates)"
                    >
                      确定
                    </v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="curVisible = false"
          >
            取消
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="search"
          >
            查询
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import moment from 'moment'
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    create_time: [],
    peccancy_type: '',
    run_type: '',
    car_no: '',
    seq_code: '',
    dept: '',
    us_text: '',
    car_type: '',
    car_no_color: '',
    car_color: '',
    peccancyItems: [
      { state: '全部', abbr: '' },
      { state: '正常', abbr: '正常' },
      { state: '超速', abbr: '超速' }
    ],
    runItems: [
      { state: '全部', abbr: '' },
      { state: '顺行', abbr: '顺行' },
      { state: '逆行', abbr: '逆行' }
    ],
    siteItems: [
      { state: '全部', abbr: '' }
    ],
    dates: [],
    modal: false,
    siteDisable: false
  }),
  computed: {
    curVisible: {
      get() {
        return this.visible
      },
      set(val) {
        var that = this
        that.$emit('update:visible', val)
      }
    },
    dateRangeText() {
      return this.dates.join(' ~ ')
    }
  },
  mounted() {
    var that = this
    var starttime = moment().startOf('month').format('YYYY-MM-DD')
    var endtime = moment().endOf('month').format('YYYY-MM-DD') // 下个月末

    that.dates = [starttime, endtime]
    that.getCamDevList()
  },
  methods: {
    async getCamDevList() {
      var that = this
      await that.$api.bz.queryCamDevAllList().then(res => {
        // console.log('queryCamDevAllList', res);
        if (!res.success) {
          console.log('获取摄像机列表失败', res);
          return
        }
        var data = res.data
        that.siteItems = [{ state: '全部', abbr: '' }]
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          that.siteItems.push({ 'state': item.cam_name, 'abbr': item.seq_code })
        }

      })
    },
    search() {
      var that = this
      var obj = {
        create_time: that.dates,
        peccancy_type: that.peccancy_type,
        run_type: that.run_type,
        car_no: that.car_no,
        seq_code: that.seq_code,
        dept: that.dept,
        us_text: that.us_text,
        car_type: that.car_type,
        car_no_color: that.car_no_color,
        car_color: that.car_color
      }
      that.$emit('search', obj)
      that.curVisible = false
    },
    setData(obj) {
      var that = this
      that.create_time = obj.create_time
      that.peccancy_type = obj.peccancy_type
      that.run_type = obj.run_type
      that.car_no = obj.car_no
      that.seq_code = obj.seq_code
      that.dept = obj.dept
      that.us_text = obj.us_text
      that.car_type = obj.car_type
      that.car_no_color = obj.car_no_color
      that.car_color = obj.car_color

      if (obj.seq_code) {
        that.siteDisable = true
      } else {
        that.siteDisable = false
      }
    }
  }
}
</script>
